import Service from './Service';

export default class HsmSubnetNameService extends Service{
    constructor() {
        super();
        this.baseURL = 'hsmsubnetname';
    }
}